import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { modalController } from "@ionic/vue";
import { ref, computed, onMounted } from "vue";
import { route } from "@/router";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import FilterHeader from "@/components/modal/FilterHeader.vue";
import FilterInterface from "@/components/modal/FilterInterface.vue";

import { useSupplierStore } from "@/stores/suppliers";
import { useListStore } from "@/stores/lists";
import { usePersistentStore } from "@/stores/persistent";

import { isApp } from "@/functions/enviroment";

import { useLoader } from "@/composables/useLoader";
import { useCatalogFilter } from "@/composables/viewFunctions/useCatalogFilter";

import { SORT_METHOD } from "@/types/enum/propEnum";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterListModal',
  props: {
    supplierId: {}
  },
  setup(__props: any) {

const props = __props

const listStore = useListStore()
const supplierStore = useSupplierStore()
const { showLoading } = useLoader()

const tempCategory = ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.category)))
const tempTags = ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.tags)))
const withQuantity = ref<boolean>(JSON.parse(JSON.stringify(listStore.listFilter.withQuantity)))

const listId = computed<string>(() => route.value.params.listId as string)
const locationId = computed<string>(() => route.value.params.locationId as string)

const { tempSortDirection, getCatalogItems } = useCatalogFilter(listId.value)

const resetChanges = async (): Promise<void> => {
    if (!listId.value) {
        supplierStore.catalogFilter.sortDirection = SORT_METHOD.ALPH_ASC
    } else {
        listStore.listFilter.sortDirection = SORT_METHOD.MANUAL
    }
    listStore.listFilter.category = {}
    listStore.listFilter.tags = {}
    listStore.listFilter.withQuantity = false

    if (!isApp()) {
        await modalController.dismiss()
        return
    }

    await showLoading()
    await getCatalogItems(props.supplierId)
}

const applyChanges = async (): Promise<void> => {
    listStore.listFilter.sortDirection = tempSortDirection.value
    listStore.listFilter.tags = tempTags.value
    listStore.listFilter.category = tempCategory.value
    listStore.listFilter.withQuantity = withQuantity.value

    if (!isApp()) {
        await modalController.dismiss()
        return
    }

    await showLoading()
    await getCatalogItems(props.supplierId)
}

onMounted(() => {
    if (usePersistentStore().offlineMode) return
    if (props.supplierId) supplierStore.getSupplierCategories(locationId.value, props.supplierId)
    listStore.getTags(locationId.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, { "content-class": "light-light-background" }, {
    header: _withCtx(() => [
      _createVNode(FilterHeader, {
        title: _ctx.$t('object.filter'),
        onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss()))
      }, null, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createVNode(FilterInterface, {
        style: {"max-height":"350px"},
        tempCategory: tempCategory.value,
        "onUpdate:tempCategory": _cache[1] || (_cache[1] = ($event: any) => ((tempCategory).value = $event)),
        tempTags: tempTags.value,
        "onUpdate:tempTags": _cache[2] || (_cache[2] = ($event: any) => ((tempTags).value = $event)),
        withQuantity: withQuantity.value,
        "onUpdate:withQuantity": _cache[3] || (_cache[3] = ($event: any) => ((withQuantity).value = $event)),
        "sort-direction": _unref(tempSortDirection),
        "onUpdate:sortDirection": _cache[4] || (_cache[4] = ($event: any) => (_isRef(tempSortDirection) ? (tempSortDirection).value = $event : null)),
        onReset: resetChanges,
        onApply: applyChanges,
        "supplier-id": __props.supplierId,
        "own-categories": _unref(listStore).recommendedTags.data,
        "is-list": ""
      }, null, 8, ["tempCategory", "tempTags", "withQuantity", "sort-direction", "supplier-id", "own-categories"])
    ]),
    _: 1
  }))
}
}

})